import React, {useMemo, useCallback} from 'react'
import PropTypes from 'prop-types'
import {Flex, useStyleConfig, Progress, VisuallyHidden} from '@chakra-ui/react'
import {FormattedMessage, useIntl} from 'react-intl'

const RatingsBreakdown = ({breakdown, reviewcount}) => {
    const styles = useStyleConfig('RatingsBreakdown')
    const {formatMessage} = useIntl()

    const getRatings = useCallback(() => {
        const starsAndBars = []
        const ratingCounts = []

        breakdown?.forEach?.(({rating, count}, index) => {
            starsAndBars.push(
                <Flex key={`${index}-1`} {...styles.starsAndBarItemWrapper} tabindex="0">
                    <Flex {...styles.ratingLabel} aria-hidden={true}>
                        <FormattedMessage
                            defaultMessage="{count, plural, one {# Star} other {# Stars}}"
                            id="reviews.star_label"
                            values={{count: rating}}
                        />
                    </Flex>
                    <Progress
                        data-testid="rating-bar"
                        value={(count / reviewcount) * 100}
                        aria-hidden={true}
                        {...styles.progressBar}
                        sx={{
                            '& > div': {
                                background: 'black'
                            }
                        }}
                    />
                    <VisuallyHidden>
                        {formatMessage(
                            {
                                id: 'reviews.progress.assistive_msg.number_of_stars_and_rating_numbers',
                                defaultMessage:
                                    'Rating of {stars, plural, one {# Star} other {# Stars}} with {reviews, plural, one {# Review} other {# Reviews}}'
                            },
                            {stars: rating, reviews: count}
                        )}
                    </VisuallyHidden>
                </Flex>
            )

            ratingCounts.push(
                <Flex {...styles.countItem} data-testid="rating-count" key={`${index}-2`}>
                    {count}
                </Flex>
            )
        })

        return {starsAndBars, ratingCounts}
    }, [breakdown, reviewcount, styles, formatMessage])

    const {starsAndBars, ratingCounts} = useMemo(() => getRatings(), [getRatings])

    return (
        <Flex direction="column" data-testid="ratings-breakdown" {...styles.container}>
            <Flex {...styles.starsAndBarsContainer}>{starsAndBars}</Flex>
            <Flex {...styles.ratingCountsContainer}>{ratingCounts}</Flex>
        </Flex>
    )
}

RatingsBreakdown.propTypes = {
    breakdown: PropTypes.array,
    ratings: PropTypes.array,
    reviewcount: PropTypes.number
}

export default RatingsBreakdown
